import React from 'react';
import JSONLDOrganization from './JSONLDOrganization';
import { RETURN_POLICY } from './boosthiveSchema';

const ADDRESS = {
  streetAddress: 'Andrea Zakou 2, Flat/Office 202',
  addressLocality: 'Egkomi',
  addressRegion: 'Nicosia',
  postalCode: '2404',
  addressCountry: 'CY',
};

const CONTACT_POINT = {
  contactType: 'Customer Service',
  email: 'support@boosthive.eu',
};

const SAME_AS = [
  'https://www.linkedin.com/company/boosthiveeu',
  'https://facebook.com/boosthive',
  'https://x.com/boosthive',
  'https://www.instagram.com/boosthive.eu',
  'https://www.youtube.com/@boosthive-eu',
  'https://www.trustpilot.com/review/boosthive.eu',
];

export default function JSONLDBoosthive() {
  return (
    <JSONLDOrganization
      name="Boosthive"
      legalName="Alisavor Management Limited"
      alternateName="hiveboost"
      url={process.env.PUBLIC_URL}
      logo={`${process.env.PUBLIC_URL}/logo-icon.png`}
      email="support@boosthive.eu"
      vatID="CY10402193N"
      slogan="Play More. Grind Less."
      description="Gaming services platform helping players achieve their in-game goals since 2014."
      foundingDate="2014"
      numberOfEmployees={{minValue: 10, maxValue: 99}}
      address={ADDRESS}
      contactPoint={CONTACT_POINT}
      hasMerchantReturnPolicy={RETURN_POLICY}
      sameAs={SAME_AS}
    />
  );
}



// WEBPACK FOOTER //
// ./components/JSON-LD/JSONLDBoosthive.js